import http from "../HttpInterceptor";

const getAll = (param: any) => {
  return http.get("gateway/getcalllogissues?param=" + param, {
    headers: {'task_name': 'getcalllogissues'}
});
};

const getAllMsg = (param: any) => {
  return http.get("gateway/getMsgLogIssues?param=" + param, {
    headers: {'task_name': 'getMsgLogIssues'}
});
};


const save = (data: any) => {
  return http.post("gateway/updatecalllogissue", data, {
    headers: {'task_name': 'updatecalllogissue'}
});
};

const updateChatIssue = (data: any) => {
  return http.post("gateway/updateMSGLogIssues", data, {
    headers: {'task_name': 'updateMSGLogIssues'}
});
};

export default {
  getAll,
  getAllMsg,
  // get,
  save,
  updateChatIssue
};